import './App.css';
import React, { useState, useEffect } from 'react';  // <-- Import React, useState, and useEffect
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/home/index.tsx';
import { WhyThy } from './pages/why-thy/index.tsx';
import { Services } from './pages/services/index.tsx';
import { ContactUs } from './pages/contactUs/index.tsx';
import { Products } from './pages/products/index.tsx';
import { LoginPage } from './pages/admin/login/index.tsx';
import { AdminPanel } from './pages/admin/panel/index.tsx';
import { Enquiries } from './pages/admin/enquiries/index.tsx';
import { Reviews } from './pages/admin/reviews/index.tsx';
import { Portfolio } from './pages/admin/portfolio/index.tsx';
import { ProductsPage } from './pages/admin/products/index.tsx';

// 🔧 Make sure to import your animation asset
import LogoAnimation from '../src/assets/images/720p.gif'; // <-- Update path as needed

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Example of calling an API or loading data (e.g., getReviews)
    const timer = setTimeout(() => setLoading(false), 2000); // show loading for 3 seconds
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{
        display: "flex",
        height: "100vh",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        background:"#030303"
      }}>
        <img
          style={{ width: "80%", height: "80%", objectFit: "contain" }}
          src={LogoAnimation}
          alt="Loading..."
        />
      </div>
    );
  }

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why_thy" element={<WhyThy />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact_us" element={<ContactUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPanel />}>
            <Route path="reviews" element={<Reviews />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="enquiries" element={<Enquiries />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
